<script>
import { mapState, mapActions } from 'vuex';

export default {
  template: '#comment-display',
  data() {
    return {};
  },
  created() {},
  methods: {},
  computed: {
    ...mapState(['general']),
    ...mapActions(['general/setNewCommentPhase'])
  }
};
</script>
